import { render, staticRenderFns } from "./SchoolDetails.vue?vue&type=template&id=07dcbfab&scoped=true&"
import script from "./SchoolDetails.vue?vue&type=script&lang=js&"
export * from "./SchoolDetails.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDetails.vue?vue&type=style&index=0&id=07dcbfab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dcbfab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
